import graphql__9b77f686b4b3d5a4a784 from "./__generated__/ContributionHeader_contribution.graphql.js";import { graphql, useFragment } from "react-relay";
import { useFormatDate, useFormatMessage } from "../Intl/Context";
import parseDate from "../Utils/parseDate";
import { defineMessages } from "../../../../node_modules/react-intl/index";
import UserAvatar from "../Users/UserAvatar";
import UserAuthorName from "../Users/UserAuthorName";
import { useRoutesContext } from "../Routes/RoutesContext";
import { useHighlightSearch } from "../ResourcesList/resourcesList";
import ContributionWithRequiredModerationBadge from "../ParticipativeModule/Visualizations/ContributionWithRequiredModerationBadge";
import { isAuthorized, isUnauthorized } from "../Utils/authorizations";
import classNames from "../../../../node_modules/classnames/index";
import ContributorContactButton from "./ContributorContact/ContributorContactButton";
import ButtonLink from "../Buttons/ButtonLink";

const ContributionHeader = props => {
  const contribution = useFragment(ContributionHeader_contribution, props.contribution);
  const { author, participativeModule } = contribution;

  const formatDate = useFormatDate();
  const publishedAtDate = parseDate(contribution.publishedAt);
  const publishedAt = formatDate(publishedAtDate, { hour: "numeric", minute: "numeric" });

  const t = useFormatMessage();
  const publicationDate = t(intlMessages.publicationDate, { date: publishedAt });
  const editContributionLabel = t(intlMessages.editContribution);

  const { pathFor } = useRoutesContext();
  const editContributionPath = pathFor("editContribution", {
    participativeModuleSlug: participativeModule.slug,
    contributionSlug: contribution.slug
  });

  const highlightSearch = useHighlightSearch();

  const { editContribution, contributorContactAuthorized, requiresModeration } =
    contribution.authorizations;

  const contributionEditionAuthorized = isAuthorized(editContribution);
  const contributorContactAuthorizedFlag = !isUnauthorized(contributorContactAuthorized);
  const displayActionsContainer =
    contributionEditionAuthorized ||
    contributorContactAuthorizedFlag ||
    requiresModeration;

  const contributionModerationBadgeClassName = classNames("margin-bottom-sm", {
    "margin-left-xs": contributionEditionAuthorized
  });

  return (
    <>
      <div className="d-flex justify-content-between align-items-center padding-none margin-bottom-xs">
        <div className="d-flex padding-none margin-bottom-sm">
          <UserAvatar className="contribution-author-avatar" user={author} size={35} />

          <div>
            <UserAuthorName
              user={author}
              name={highlightSearch(author.name)}
              ContainerComponent="h4"
            />

            <div className="contribution-publication-date text-title-overview-sm text-muted">
              {publicationDate}
            </div>
          </div>
        </div>
      </div>

      {displayActionsContainer && (
        <div className="d-flex align-items-center">
          <ContributorContactButton
            contribution={contribution}
            className="margin-right-xs margin-bottom-xs"
          />

          {contributionEditionAuthorized && (
            <ButtonLink
              type="button"
              href={editContributionPath}
              className="btn btn-primary-inverse btn-shadow btn-sm margin-bottom-sm"
              iconClassName="icon-pencil"
              label={editContributionLabel}
            />
          )}

          <ContributionWithRequiredModerationBadge
            contribution={contribution}
            className={contributionModerationBadgeClassName}
          />
        </div>
      )}
    </>
  );
};

const ContributionHeader_contribution = graphql__9b77f686b4b3d5a4a784;

export default ContributionHeader;

const intlMessages = defineMessages({
  publicationDate: {
    id: "contribution.card.publicationDate",
    defaultMessage: "Publiée le {date}"
  },
  editContribution: {
    id: "contribution.card.editContribution",
    defaultMessage: "Modifier la contribution"
  }
});
